module.exports = __webpack_public_path__ + "img/ktb-bank46x46.cb50db21.jpg";